// extracted by mini-css-extract-plugin
export default {"underPage":"UnderPage__underPage__mRiHg","scrollable":"UnderPage__scrollable__lLVkq"};